const config = {
  configEndpoints: {
    baseEndpoint: "http://localhost:9000/partner",
  },
};

export default config;
